import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circle-arrow-button',
  templateUrl: './circle-arrow-button.component.html',
  styleUrls: ['./circle-arrow-button.component.scss'],
})
export class CircleArrowButtonComponent {
  @Input()
  enableToggle = false;

  @Input()
  unfolded = false;

  @Input()
  transparent: boolean;

  @Input()
  isStatic: boolean;

  isUnfolded() {
    return this.unfolded;
  }
}
